import CoreReactChangelogs from "../../../../../core-react/CHANGELOG.md";
import * as React from 'react';
export default {
  CoreReactChangelogs,
  React
};